export default function AboutSection() {
  return (
    <section id="about" className="relative py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-50 mb-3">关于大师兄</h2>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="bg-background-100 rounded-2xl p-8 md:p-10 border border-background-200/50">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-500/15">
                <i className="ri-movie-2-line text-2xl text-primary-400"></i>
              </span>
              <div>
                <h3 className="text-xl font-heading text-foreground-100">大师兄影视</h3>
                <p className="text-xs text-foreground-500">始于热爱，忠于品质</p>
              </div>
            </div>
            <div className="space-y-4 text-foreground-400 leading-relaxed text-sm md:text-base">
              <p>
                大师兄影视是一个专注于<strong className="text-foreground-200">高清影视在线观看</strong>的综合平台，致力于为广大影迷提供<strong className="text-foreground-200">电视剧全集、电影大全、综艺节目、热门剧集与经典影片</strong>的一站式观影服务。
              </p>
              <p>
                我们拥有先进的不缓冲秒开播放技术和极速加载流畅观影引擎，确保每位用户都能享受到顺畅无阻的观影体验。海量片库每日持续更新，从最新热播大剧到经典老片修复版，一网打尽。
              </p>
              <p>
                无论您是追剧达人、电影发烧友还是综艺爱好者，大师兄影视都是您值得信赖的观影伙伴。我们始终坚持以用户体验为核心，持续优化播放技术和内容覆盖。
              </p>
            </div>
            <div className="grid grid-cols-3 gap-4 mt-8 pt-6 border-t border-background-200/40">
              <div className="text-center">
                <div className="text-xl font-bold text-primary-400 font-heading">5年</div>
                <div className="text-xs text-foreground-600 mt-1">稳定运营</div>
              </div>
              <div className="text-center">
                <div className="text-xl font-bold text-primary-400 font-heading">10000+</div>
                <div className="text-xs text-foreground-600 mt-1">影视资源</div>
              </div>
              <div className="text-center">
                <div className="text-xl font-bold text-primary-400 font-heading">99.9%</div>
                <div className="text-xs text-foreground-600 mt-1">服务可用率</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}